import { makeAuthorizedRequest } from './requests';

export function getHolidays() {
  return makeAuthorizedRequest('GET', '/holidays');
}
